import apiClient from './client';

export interface BlogPost {
	id: number;
	article_id: number;
	slug: string;
	title: string;
	lead: string;
	content: string;
	image: string;
	image_width: number | null;
	image_height: number | null;
	datetime_created: string;
	datetime_modified: string;
	status: string;
	category_name: string;
	category_slug: string;
	link: string;
	seo_score: number | null;
	// Single article fields
	meta_title: string | null;
	meta_description: string | null;
	og_title: string | null;
	og_description: string | null;
	// E-E-A-T / freshness fields surfaced by content_manager#GetOneBySlug for the
	// visible author line, "Frissítve" line and JSON-LD (mirrors the PHP sites).
	author_name?: string | null;
	reviewer_name?: string | null;
	reviewer_credential?: string | null;
	published_at?: string | null;
	// Published chain FAQ rows -> visible GYIK block + FAQPage JSON-LD.
	faq?: { question: string; answer: string }[];
	category: {
		id: number;
		name: string;
		slug: string;
		lead: string | null;
		description: string | null;
	} | null;
	blogs: BlogPost[];
}

export interface BlogCategory {
	id: number;
	name: string;
	slug: string;
	lead: string | null;
	description: string | null;
}

export const getPosts = (categorySlug?: string) =>
	apiClient.get<{ data: BlogPost[] }>('/blog', {
		params: categorySlug ? { category: categorySlug } : undefined,
	});

export const getPost = (slug: string) =>
	apiClient.get<{ data: BlogPost }>(`/blog/${slug}`);

export const getCategories = () =>
	apiClient.get<{ data: BlogCategory[] }>('/blog/categories');
